import {ContactEvent, Dealer} from './customer-client-response.data';

export class CustomerWizardResponse {
  tecCustomerId: string;
  firstName: string;
  lastName: string;
  companyname: string;
  primaryAddress: CustomerAddress;
  emailPersonal: string;
  emailOffice: string;
  phoneMobile: string;
  phoneHome: string;
  phoneOffice: string;
  dealer: Dealer;
  customerNumber: string;
  currentConsentVersion: string;
  contactEventList: ContactEvent[];
}

export class CustomerAddress {
  street: string;
  postcode: string;
  city: string;
}
